import { parseAsBoolean, useQueryState } from 'nuqs'
import { useEffect } from 'react'
import { toast } from 'sonner'

export default function useAutoShowToastWhenSessionExpired() {
	const [sessionExpired, setSessionExpired] = useQueryState(
		'sessionExpired',
		parseAsBoolean.withDefault(false),
	)

	useEffect(() => {
		setTimeout(() => {
			if (sessionExpired) {
				toast.error('Session has been expired. Please login again.', {
					position: 'top-right',
				})

				setSessionExpired(false)
			}
		})
	}, [])
}
